/**
 * ticket模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const ticket = {
  // 创建案例
  createTicket(params) {
    return $http.post(`${global.API_URL}/sme/ticket/create`,params);
  },
  // 案例分页
  pageTicket(params) {
    return $http.post(`${global.API_URL}/sme/ticket/page`,params);
  },
  // 案例删除
  deleteTicket(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/delete`,param);
  },
  // 更新案例
  updateTicket(params) {
    return $http.post(`${global.API_URL}/sme/ticket/update`,params);
  },
  // 根据id查询案例
  selectTicket(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/select`,param);
  },
  // 操作日志
  operationLog(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/operationLog`,param);
  },
  // 导出
  export(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/export`,param,{
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 通过问题类型查询案例
  queryTicketByQuestionType(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/queryTicketByQuestionType`,param);
  },
  // 查询平均响应时间
  selectTicketAverageResponseTime(param){
    return $http.post(`${global.API_URL}/sme/ticket/selectTicketAverageResponseTime`,param);
  },
  // 查询续买下拉框
  getContinuePurchaseBox(param){
    return $http.post(`${global.API_URL}/sme/ticket/getContinuePurchaseBox`,param);
  },
  // 下载Excel文件
  exportTicket(params) {
    return $http.post(`${global.API_URL}/sme/ticket/exportTicket`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 获取下拉框
  getProblemType(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getProblemType`,params);
  },
   // 定时查询时间 有案例响铃
  isNeedReminder(params) {
    return $http.post(`${global.API_URL}/sme/ticket/isNeedReminder`,params);
  },
  // 通过时间获取案例
  getTicketByTime(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getTicketByTime`,params);
  },
  // 下载ticketKPI文件
  exportTicketKPI(params) {
    return $http.post(`${global.API_URL}/sme/ticket/exportTicketKPI`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 案例统计信息
  getTicketStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getTicketStatistics`,params);
  },
  // 文档统计信息
  getCompanyContributionStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getCompanyContributionStatistics`,params);
  },
  // SLA
  getSlaStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getSlaStatistics`,params);
  },
  // SLA详情
  getSlaDetails(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getSlaDetails`,params);
  },
  // 导出案例统计信息
  exportTicketStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/exportTicketStatistics`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 导出文档统计信息
  exportCompanyContributionStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/exportCompanyContributionStatistics`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 点击确认
  confirmTicket(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/ticket/confirm`,param);
  },
  // 通过状态获取列表
  getTicketListByStatus(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getTicketListByStatus`,params);
  },
  // 获取案例趋势图
  getTicketTrend(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getTicketTrend`,params);
  },
  // 导出sla
  exportSlaParticulars(params) {
    return $http.post(`${global.API_URL}/sme/ticket/exportSlaParticulars`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 获取案例状态
  queryTicketByType(params) {
    return $http.post(`${global.API_URL}/sme/ticket/queryTicketByType`,params);
  },
  // 各级别案例SLA分析统计图
  getSlaTicketAnalyzeStatistics(params) {
    return $http.post(`${global.API_URL}/sme/ticket/getSlaTicketAnalyzeStatistics`,params);
  },
  // 一键分配
  processEasy(params) {
    return $http.post(`${global.API_URL}/sme/ticket/processEasy`,params);
  },
  // 导入
  importFile(params) {
    return $http.post(`${global.API_URL}/sme/ticket/importFile`,params);
  },
  // RI 续购：确认续购（按文档 POST /sme/agentverse/ticket/ri/confirmRenewal，必传 ticketEntityId、assigneeUserId）
  confirmRiRenew(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/ticket/ri/confirmRenewal`, params);
  },
  // RI 续购：无需续购（按文档 POST /sme/agentverse/ticket/ri/rejectRenewal，必传 ticketEntityId）
  rejectRiRenew(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/ticket/ri/rejectRenewal`, params);
  },
  // RI 续购：购买确认（二线确认）（按文档 PUT /sme/agentverse/ticket/ri/purchaseConfirm/{ticketNumber}）
  purchaseConfirm(ticketNumber) {
    return $http.put(`${global.API_URL}/sme/agentverse/ticket/ri/purchaseConfirm/${ticketNumber}`);
  },
};

export default ticket;



// WEBPACK FOOTER //
// ./src/api/ticket.js